module.exports = __webpack_public_path__ + "static/media/shop-popular.bcbb9cee.png";